import React, { useState } from 'react';
import { DropDownList } from "@progress/kendo-react-dropdowns";

export const ActionDoneFilterCell = (props) => {
    const [value, setValue] = useState(props.defaultItem);

  const onChange = (event) => {
    setValue(event.target.value);

    props.onChange({
      value: event.target.value,
      operator: "contains",
      syntheticEvent: event.syntheticEvent,
    });
  };

  return (
    <div className="k-filtercell">
      <DropDownList
        data={props.data}
        onChange={onChange}
        value={value}
        defaultItem={props.defaultItem}
      />
    </div>
  );
};